import propertyImagePlaceholderSvg from '../../../../../assets/property-image-placeholder.svg';
import { isListingImage } from '../../../../../app-kit/components/PropertyTile/PropertyTile.types';
import { paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import type { AerialImage, ListingImage } from './FollowPropertyImage.types';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';

const StyledImage = styled.img`
  width: 100%;
  aspect-ratio: 16 / 9;
  background-color: ${paletteHelper('backgroundHoveredPrimary')};
  border-radius: ${spacingHelper('extraSmall extraSmall 0 0')};
`;

const PropertyImage = styled(StyledImage)`
  display: block;
`;

const PropertyAerialImage = styled(StyledImage)`
  display: block;
  object-fit: cover;
`;

const PropertyImagePlaceholder = styled(StyledImage)`
  display: block;
  object-fit: cover;
  background-color: ${paletteHelper('graphicGrey')};
`;

const PropertyImageWrapper = styled.picture`
  position: relative;
`;

interface FollowPropertyImageProps {
  image?: ListingImage | AerialImage | null;
}

export const FollowPropertyImage: FunctionComponent<FollowPropertyImageProps> = ({ image }) => {
  if (!image) {
    return (
      <PropertyImagePlaceholder
        src={propertyImagePlaceholderSvg}
        alt="Property image placeholder"
      />
    );
  }

  if (isListingImage(image)) {
    return (
      <PropertyImageWrapper>
        <source srcSet={image.webpUri} />
        <PropertyImage src={image.jpgUri} alt={image.alt} />
      </PropertyImageWrapper>
    );
  }

  return (
    <PropertyImageWrapper>
      <PropertyAerialImage src={image.uri} alt={image.alt} />
    </PropertyImageWrapper>
  );
};
